module.exports = __webpack_public_path__ + "img/donate-wechatpay-10.255a564c.png";